import React, { useState, useEffect, useCallback, useReducer } from 'react';

import { CustomerConstants } from '../../Helpers/requests';
import { GetAuth } from '../../Auth/AuthProvider';

import CustomerList from './CustomerList';
import CustomerActionCard from './CustomerActionCard';

import UnauthorisedAccess from '../CommonComponents/UnauthorisedAccess';

import { Card } from '@mui/material';

function Customer() {
  const [categoriesData, setCategoriesData] = useState([]); //Constant - Categories List
  const [regionsData, setRegionsData] = useState([]); //Constant - Regions List
  const [asset_compData, setAsset_compData] = useState([]); //Constant - Asset Comp List
  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function

  const [, updateState] = useReducer((x) => x + 1, 0);
  const forceUpdate = useCallback(() => updateState({}), []);


  const [useType, setUseType] = useState(localStorage.getItem('type'));

  useEffect(() => {
    CustomerConstants({
      resource: `/api/constants/customer`,
      setCategoriesFunc: setCategoriesData,
      setRegionsFunc: setRegionsData,
      setAsset_compFunc: setAsset_compData,
      // setLoadingFunc: setLoading,
      showNotification: enqNotification,
      logout,
    });
  }, [enqNotification, logout, forceUpdate]);

  return useType === 'technician' ? <UnauthorisedAccess /> :  (
    <Card
      sx={{
        maxHeight: '86.3vh',
        minHeight: '86.3vh',
        background: 'none',
        // boxShadow: 'none',
        paddingBottom: '17px',
      }}
    >
      <CustomerList
        categoriesData={categoriesData}
        regionsData={regionsData}
        asset_compData={asset_compData}
      />
      <CustomerActionCard
        category={categoriesData[0]}
        region={regionsData[0]}
        asset_man_comp={asset_compData[0]}
      />
    </Card>
  );
}

export default Customer;
